import { render, staticRenderFns } from "./coupon-scope-list.vue?vue&type=template&id=882d9d24&scoped=true&"
import script from "./coupon-scope-list.vue?vue&type=script&lang=js&"
export * from "./coupon-scope-list.vue?vue&type=script&lang=js&"
import style0 from "./coupon-scope-list.vue?vue&type=style&index=0&id=882d9d24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882d9d24",
  null
  
)

export default component.exports